import { gql } from 'graphql-tag'

export const fetchMarketSettings = gql`
  query FetchMarketSettings {
    chainMarketSettings {
      id
      name
      startDate
      endDate
      value
    }
  }
`

export const addChainMarketSettings = gql`
  mutation AddChainMarketSettings($data: ChainMarketSettingsInput!) {
    addChainMarketSettings(data: $data) {
      name
      value
      startDate
      endDate
    }
  }
`

export const updateChainMarketSettings = gql`
  mutation UpdateChainMarketSettings($id: ID!, $data: ChainMarketSettingsInput!) {
    updateChainMarketSettings(id: $id, data: $data) {
      name
      value
      startDate
      endDate
    }
  }
`

export const deleteChainMarketSettings = gql`
  mutation DeleteChainMarketSettings($id: ID!) {
    deleteChainMarketSettings(id: $id) {
      id
    }
  }
`
